export default __webpack_public_path__ + "static/media/lynnReflex.f22fb755.png";